export default __webpack_public_path__ + "static/media/2_english.d78eadd6.jpg";